import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import { useLanguage } from '../hooks/useLanguage'

function getAvatarUrl(path) {
  if (!path) return ''
  const { data: { publicUrl } } = supabase.storage.from('avatars').getPublicUrl(path)
  return publicUrl
}

// ─────────────────────────────────────────────────────────────
// LISTA DE CHATS
// ─────────────────────────────────────────────────────────────

function FriendList({ user, friends, lastMessages, unreadCounts, onSelect, onBack, t }) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', flexDirection: 'column' }}>
      {/* HEADER */}
      <div style={{
        background: 'var(--color-surface)',
        borderBottom: '1px solid var(--color-border)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        position: 'sticky',
        top: 0,
        zIndex: 10
      }}>
        <div style={{ fontSize: 20, fontWeight: 800, color: 'var(--color-text)' }}>
          💬 {t('mensajes_header')}
        </div>
        <button
          onClick={onBack}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            background: 'var(--color-surface)', border: '1px solid var(--color-border)',
            color: 'var(--color-text)', padding: '9px 14px', borderRadius: 14,
            cursor: 'pointer', fontWeight: 700, fontSize: 13, transition: '0.2s',
            flexShrink: 0, whiteSpace: 'nowrap'
          }}
        >
          {t('volver')}
        </button>
      </div>

      {/* LISTA */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {friends.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300, gap: 14, color: 'var(--color-muted)' }}>
            <div style={{ fontSize: 48 }}>💬</div>
            <div style={{ fontSize: 15, fontWeight: 600 }}>{t('sin_conversaciones')}</div>
            <div style={{ fontSize: 13 }}>{t('agrega_amigos_chatear')}</div>
          </div>
        ) : (
          friends.map(f => {
            const avatarUrl = f.profile?.avatar_path ? getAvatarUrl(f.profile.avatar_path) : null
            const displayName =
              (f.user_id === user.id ? f.nickname_user : f.nickname_friend) ||
              f.profile?.full_name || t('usuario_generico')
            const last = lastMessages[f.profile?.id] || null
            const unread = unreadCounts[f.profile?.id] || 0

            return (
              <button
                key={f.id}
                onClick={() => onSelect(f)}
                style={{
                  width: '100%', background: 'none', border: 'none',
                  borderBottom: '1px solid var(--color-border)',
                  padding: '14px 20px', display: 'flex', alignItems: 'center',
                  gap: 14, cursor: 'pointer', transition: '0.15s', boxSizing: 'border-box'
                }}
              >
                {/* AVATAR */}
                <div style={{
                  width: 52, height: 52, borderRadius: '50%', overflow: 'hidden',
                  background: 'var(--color-primary-lt)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', fontSize: 20,
                  fontWeight: 700, color: 'var(--color-primary)', flexShrink: 0,
                  position: 'relative'
                }}>
                  {avatarUrl
                    ? <img src={avatarUrl} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    : displayName.charAt(0).toUpperCase()
                  }
                  {/* Badge no leídos sobre avatar */}
                  {unread > 0 && (
                    <div style={{
                      position: 'absolute', top: -2, right: -2,
                      minWidth: 18, height: 18, borderRadius: 999,
                      background: '#22c55e', border: '2px solid var(--color-bg)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 10, fontWeight: 700, color: 'white', padding: '0 3px'
                    }}>
                      {unread > 9 ? '9+' : unread}
                    </div>
                  )}
                </div>

                {/* INFO */}
                <div style={{ flex: 1, textAlign: 'left', minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                    <div style={{
                      fontSize: 15,
                      fontWeight: unread > 0 ? 800 : 700,
                      color: 'var(--color-text)',
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                    }}>
                      {displayName}
                    </div>
                    {last && (
                      <div style={{ fontSize: 11, color: unread > 0 ? 'var(--color-primary)' : 'var(--color-muted)', flexShrink: 0, marginLeft: 8, fontWeight: unread > 0 ? 700 : 400 }}>
                        {new Date(last.created_at).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{
                      fontSize: 13,
                      color: unread > 0 ? 'var(--color-text)' : 'var(--color-muted)',
                      fontWeight: unread > 0 ? 600 : 400,
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                      flex: 1
                    }}>
                      {last
                        ? (last.sender_id === user.id ? t('tu_dos_puntos') : '') + last.content
                        : t('sin_mensajes_aun')}
                    </div>
                    {/* Punto verde si hay no leídos */}
                    {unread > 0 && (
                      <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
                    )}
                  </div>
                </div>

                <div style={{ fontSize: 16, color: 'var(--color-muted)', flexShrink: 0 }}>›</div>
              </button>
            )
          })
        )}
      </div>
    </div>
  )
}

// ─────────────────────────────────────────────────────────────
// CHAT
// ─────────────────────────────────────────────────────────────

function ChatScreen({ user, friend, onBack, onMarkRead, t }) {
  const [messages, setMessages] = useState([])
  const [text, setText] = useState('')
  const [sending, setSending] = useState(false)
  const bottomRef = useRef(null)

  const friendUserId = friend.user_id === user.id ? friend.friend_id : friend.user_id
  const displayName =
    (friend.user_id === user.id ? friend.nickname_user : friend.nickname_friend) ||
    friend.profile?.full_name || t('usuario_generico')
  const avatarUrl = friend.profile?.avatar_path ? getAvatarUrl(friend.profile.avatar_path) : null

  async function loadMessages() {
    const { data, error } = await supabase.functions.invoke('get-messages', {
      body: { user_id: user.id, friend_id: friendUserId }
    })
    if (error) { console.error(error); return }
    setMessages(data || [])
  }

  // Al abrir el chat, marcar notificaciones de ese amigo como leídas
  async function markMessagesRead() {
    await supabase.from('notifications')
      .update({ read: true })
      .eq('user_id', user.id)
      .eq('type', 'new_message')
      .eq('read', false)
      // metadata->>'from_user_id' = friendUserId
      // Usamos filter con cast
      .filter('metadata->>from_user_id', 'eq', friendUserId)

    onMarkRead(friendUserId)
  }

  useEffect(() => {
    async function init() {
      await loadMessages()
      await markMessagesRead()
    }

    init()

    const channel = supabase
    .channel('chat-' + friendUserId)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'messages'
      },
      async (payload) => {
        const msg = payload.new

        const perteneceChat =
          (
            msg.sender_id === user.id &&
            msg.receiver_id === friendUserId
          ) ||
          (
            msg.sender_id === friendUserId &&
            msg.receiver_id === user.id
          )

        if (!perteneceChat) return

        await loadMessages()
      }
    )
    .subscribe()

    return () => { supabase.removeChannel(channel) }
  }, [friendUserId, user.id])


  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  async function sendMessage() {
    if (!text.trim() || sending) return
    setSending(true)
    const plainText = text.trim()
    setText('')
    const { data, error } = await supabase.functions.invoke('send-message', {
      body: { sender_id: user.id, receiver_id: friendUserId, content: plainText }
    })
  if (!error) {
    await loadMessages()
  }
    setSending(false)
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', flexDirection: 'column' }}>
      {/* HEADER */}
      <div style={{
        background: 'var(--color-surface)', borderBottom: '1px solid var(--color-border)',
        padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12,
        position: 'sticky', top: 0, zIndex: 10
      }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--color-primary)', fontSize: 22, cursor: 'pointer', padding: '4px 8px', borderRadius: 8 }}>
          ←
        </button>
        <div style={{
          width: 40, height: 40, borderRadius: '50%', overflow: 'hidden',
          background: 'var(--color-primary-lt)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: 18, fontWeight: 700,
          color: 'var(--color-primary)', flexShrink: 0
        }}>
          {avatarUrl
            ? <img src={avatarUrl} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : displayName.charAt(0).toUpperCase()
          }
        </div>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--color-text)' }}>{displayName}</div>
          <div style={{ fontSize: 11, color: 'var(--color-muted)' }}>{friend.profile?.full_name}</div>
        </div>
      </div>

      {/* MENSAJES */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px', paddingBottom: 80, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {messages.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--color-muted)', fontSize: 13, marginTop: 60 }}>
            {t('no_hay_mensajes_decir_hola')}
          </div>
        )}
        {messages.map((msg, i) => {
          const isMe = msg.sender_id === user.id
          return (
            <div key={msg.id || i} style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
              <div style={{
                maxWidth: '72%',
                background: isMe ? 'linear-gradient(135deg,#2563eb,#1d4ed8)' : 'var(--color-surface)',
                color: isMe ? 'white' : 'var(--color-text)',
                borderRadius: isMe ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                padding: '10px 14px',
                border: isMe ? 'none' : '1px solid var(--color-border)'
              }}>
                <div style={{ fontSize: 14, lineHeight: 1.5, wordBreak: 'break-word' }}>{msg.content}</div>
                <div style={{ fontSize: 10, opacity: 0.6, marginTop: 4, textAlign: isMe ? 'right' : 'left' }}>
                  {new Date(msg.created_at).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          )
        })}
        <div ref={bottomRef} />
      </div>

      {/* INPUT */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: 'var(--color-surface)', borderTop: '1px solid var(--color-border)',
        padding: '12px 16px', display: 'flex', gap: 10, alignItems: 'center'
      }}>
        <input
          type="text"
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
          placeholder={t('escribir_mensaje_placeholder')}
          style={{
            flex: 1, background: 'var(--color-bg)', border: '1px solid var(--color-border)',
            borderRadius: 22, padding: '11px 16px', color: 'var(--color-text)',
            fontSize: 14, outline: 'none'
          }}
        />
        <button
          onClick={sendMessage}
          disabled={sending || !text.trim()}
          style={{
            width: 44, height: 44, borderRadius: '50%',
            background: text.trim() ? 'var(--color-primary)' : 'var(--color-border)',
            border: 'none', color: 'white', fontSize: 20,
            cursor: text.trim() ? 'pointer' : 'default',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: '0.2s', flexShrink: 0
          }}
        >
          ➤
        </button>
      </div>
    </div>
  )
}

// ─────────────────────────────────────────────────────────────
// EXPORT PRINCIPAL
// ─────────────────────────────────────────────────────────────

export default function Mensajes() {
  const { t } = useLanguage()
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [friends, setFriends] = useState([])
  const [lastMessages, setLastMessages] = useState({})
  const [unreadCounts, setUnreadCounts] = useState({})
  const [selectedFriend, setSelectedFriend] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => { loadData() }, [])

    useEffect(() => {
    if (!user) return

    const channel = supabase
      .channel('messages-home-' + user.id)
      .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'messages'
      },
      async (payload) => {
        const msg = payload.new

        if (
          msg.sender_id !== user.id &&
          msg.receiver_id !== user.id
        ) return

        await loadData()
      }
    )
      .subscribe()

    return () => supabase.removeChannel(channel)
  }, [user])

  async function loadData() {
    const { data } = await supabase.auth.getUser()
    if (!data.user) { navigate('/login'); return }
    setUser(data.user)

    const { data: friendsData } = await supabase
      .from('friends')
      .select('*')
      .or(`user_id.eq.${data.user.id},friend_id.eq.${data.user.id}`)
      .eq('status', 'accepted')

    if (friendsData) {
      const friendIds = friendsData.map(f =>
        f.user_id === data.user.id ? f.friend_id : f.user_id
      )

      const { data: profiles } = await supabase
        .from('profiles')
        .select('id, full_name, avatar_path')
        .in('id', friendIds)

      const formatted = friendsData.map(f => {
        const realId = f.user_id === data.user.id ? f.friend_id : f.user_id
        return { ...f, profile: profiles?.find(p => p.id === realId) }
      })

      setFriends(formatted)

      // Cargar último mensaje + notificaciones no leídas por amigo
      const lastMsgs = {}
      const unreadMap = {}

      await Promise.all([
        // Últimos mensajes
        ...friendIds.map(async fid => {
          const { data: msgs } = await supabase.functions.invoke('get-messages', {
            body: { user_id: data.user.id, friend_id: fid }
          })
          if (msgs && msgs.length > 0) {
            lastMsgs[fid] = msgs[msgs.length - 1]
          }
        }),
        // Notificaciones new_message no leídas
        (async () => {
          const { data: notiData } = await supabase
            .from('notifications')
            .select('metadata')
            .eq('user_id', data.user.id)
            .eq('type', 'new_message')
            .eq('read', false)

          ;(notiData || []).forEach(n => {
            const meta = typeof n.metadata === 'string' ? JSON.parse(n.metadata) : n.metadata
            const fromId = meta?.from_user_id
            if (fromId) {
              unreadMap[fromId] = (unreadMap[fromId] || 0) + 1
            }
          })
        })()
      ])

      setLastMessages(lastMsgs)
      setUnreadCounts(unreadMap)
    }

    setLoading(false)
  }

  // Cuando se marca un chat como leído, limpiar su badge
  function handleMarkRead(friendUserId) {
    setUnreadCounts(prev => {
      const next = { ...prev }
      delete next[friendUserId]
      return next
    })
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20, background: 'var(--color-bg)' }}>
        <style>{`
          @keyframes pulse { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.08);opacity:0.85} }
          @keyframes bounce { 0%,80%,100%{transform:translateY(0);opacity:0.5} 40%{transform:translateY(-8px);opacity:1} }
        `}</style>
        <div style={{ width: 70, height: 70, borderRadius: 20, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, animation: 'pulse 1.5s infinite' }}>💬</div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--color-text)', marginBottom: 6 }}>Calypso</div>
          <div style={{ fontSize: 14, color: 'var(--color-muted)' }}>{t('cargando_mensajes')}</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{ width: 10, height: 10, borderRadius: '50%', background: '#6366f1', animation: `bounce 0.6s infinite ${i * 0.15}s` }} />
          ))}
        </div>
      </div>
    )
  }

  if (selectedFriend) {
    return (
      <ChatScreen
        user={user}
        friend={selectedFriend}
        onBack={() => setSelectedFriend(null)}
        onMarkRead={handleMarkRead}
        t={t}
      />
    )
  }

  return (
    <FriendList
      user={user}
      friends={friends}
      lastMessages={lastMessages}
      unreadCounts={unreadCounts}
      onSelect={setSelectedFriend}
      onBack={() => navigate('/home')}
      t={t}
    />
  )
}